<template>
  <TemplatePageGrid
    :items="workClientOfficesGrid"
    :page-data="pageData"
    :loading="loadingAnimation"
    :page_params="{page: 'office_page', limit: 'office_limit'}"
  >
    <template v-slot:buttons>
      <WorkClientOfficesModal
        v-if="$userCheckAccess({abilities: 'edit_client_addresses'})"
        create
      />
    </template>
    <WorkClientOfficesTable :items="workClientOfficesGrid" />
  </TemplatePageGrid>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkClientOfficesTable from 'components/workClient/offices/WorkClientOfficesTable'
import WorkClientOfficesModal from 'components/workClient/offices/WorkClientOfficesModal'

export default {
  name: 'WorkClientOffices',
  components: {
    WorkClientOfficesTable,
    WorkClientOfficesModal,
  },
  created() {
    this.downloadPageData()
  },
  data() {
    return {}
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workClientOffices', ['workClientOfficesGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workClientOffices', ['onWorkClientOfficesGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.office_limit,
        page: this.$route.query.office_page,
        id: this.$route.params.id,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkClientOfficesGrid(data)
    },
  },
}
</script>
